import React from "react";
import "./DashboardPart.css"
import { GlobalHooks } from "../../../../utils/Hooks";
import { useTranslation } from "react-i18next";
import eventHub from "../../../../eventHub";
import { MenuItem } from "@mui/material";
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const DashboardPart = () => {
  const {cookies,setCookie} = GlobalHooks()
  const colorValue = cookies.ColorTheme === "default" ? "#1890FF" : cookies.ColorTheme === "c2" ? "#002d3d" : cookies.ColorTheme === "c3" ? "#b4c7e5" : cookies.ColorTheme === "c4" ? "#ffcd38" : cookies.ColorTheme === "c5" ? "#8ee5dc"  : "#F32B84" 
  const {t} = useTranslation()

const options =["5","10","20","30","50"]

  return (
    <div className="dashboardOptionsBorder">
      <div className='Blue-Title' style={{color:colorValue}}>{t("OptionAffichage.Dashboard")}</div>
      <h4 className="titlesDashboard">{t("OptionAffichage.Choisir le mode d'affichage de la liste des vidéos")}</h4>
      <div>
        <label >
          <input style={{accentColor:colorValue}} checked={cookies.ModeAffichage === "grand"} onChange={e=>setCookie("ModeAffichage",e.target.value,{path:"/"})} className="radio-options-profile" type="radio" name="grand" value="grand" />
          {t("OptionAffichage.Liste grande taille")}
        </label>
        <br />
        <label >
          <input style={{accentColor:colorValue}} checked={cookies.ModeAffichage === "moyenne"} onChange={e=>setCookie("ModeAffichage",e.target.value,{path:"/"})} className="radio-options-profile" type="radio" name="moyenne" value="moyenne" />
          {t("OptionAffichage.Liste moyenne taille")}
        </label>
        <br />
        <label >
          <input style={{accentColor:colorValue}} checked={cookies.ModeAffichage === "vignette"} onChange={e=>setCookie("ModeAffichage",e.target.value,{path:"/"})} className="radio-options-profile" type="radio" name="vignette" value="vignette" />
          {t("OptionAffichage.Vignettes")}
        </label>
        <br />
        <label >
          <input style={{accentColor:colorValue}} checked={cookies.ModeAffichage === "petite"} onChange={e=>setCookie("ModeAffichage",e.target.value,{path:"/"})} className="radio-options-profile" type="radio" name="petite" value="petite" />
          {t("OptionAffichage.Liste petite taille")}
        </label>
        <br />
        <label >
          <input style={{accentColor:colorValue}} checked={cookies.ModeAffichage === "repertoir"} onChange={e=>setCookie("ModeAffichage",e.target.value,{path:"/"})} className="radio-options-profile" type="radio" name="repertoir" value="repertoir" />
          {t("OptionAffichage.Répertoires")}
        </label>
        <br />
      </div>
      <h4 className="titlesDashboard">
        {t("OptionAffichage.Choisir le nombre des éléments à afficher dans la liste des vidéos")}
      </h4>
      <div className="grid-systheme-for-radios-options-table-length">
      <FormControl defaultValue={"5"}>
        <Select defaultValue={"5"} value={cookies.GridTaille} onChange={e=>setCookie("GridTaille",e.target.value,{path:"/"})} >
          {options.map((size)=> 
            <MenuItem
            value={size} 
            name={`option-${size}`} >{size}</MenuItem> 
          )}   
        </Select>
      </FormControl>
      </div>
      <h4 className="titlesDashboard">{t("OptionAffichage.Choisir les parties à afficher dans le tableau de bord")}</h4>
      <div className="checkboxes-options-affichage">
        <label>
          <input style={{accentColor:colorValue}} className="checkboxes-right-space-options" type="checkbox" name="option-2-1" value="7" />
          {t("OptionAffichage.Dernières vidéos ajoutées")}
        </label>
        <label>
          <input style={{accentColor:colorValue}} className="checkboxes-right-space-options" type="checkbox" name="option-2-2" value="8" />
          {t("OptionAffichage.Les vidéos les plus visitées")}
        </label>
        <label>
          <input style={{accentColor:colorValue}} className="checkboxes-right-space-options" type="checkbox" name="option-2-3" value="9" />
          {t("OptionAffichage.Statistiques audience")}
        </label>
        <label>
          <input style={{accentColor:colorValue}} className="checkboxes-right-space-options" type="checkbox" name="option-2-4" value="10" />
          {t("OptionAffichage.Statistiques nombre des vues par durée de visionnage")}
        </label>
      </div>
    </div>
  );
};

export default DashboardPart;
